<app-usf-product-tag-list
  [tagList]="productTags?.slice(0, 5)"
  [infoIconEnabled]="false"
  [product]="productDetails"
  [maxTags]="5"
  [allTagsClickable]="true"
  [showProductClaims]="false"
  *ngIf="productTags?.length; else emptyProperties"
  class="product-attributes-cell"
>
</app-usf-product-tag-list>
<ng-template #emptyProperties>
  <span>N/A</span>
</ng-template>
